<template>
    <div id="messages" class="js-gallery">
        <template v-if="gallery">
            <MessageBubble
                v-for="message in messages"
                :key="message.state.sid"
                :direction="message.state.author === conversationsClient.user.identity ? 'outgoing' : 'incoming'"
                :message="message"
                :conversations-client="conversationsClient"
                :conversation="conversation"
                :participants="participants"
                @add-dynamic-gallery-el="addDynamicGalleryEl($event)"
                @open-gallery="openGallery($event)"
                @reply-to="$emit('reply-to', $event)"
            />
        </template>
    </div>
</template>

<script>
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';
import 'lightgallery/css/lightgallery-bundle.min.css';
import 'lightgallery/css/lg-transitions.css';

import MessageBubble from '@components/UserChat/MessageBubble';

export default {
    components: {
        MessageBubble,
    },
    props: {
        conversationsClient: {
            type: Object,
            required: true,
            default: null,
        },
        conversation: {
            required: true,
        },
        messages: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            gallery: null,
            dynamicGalleryEl: [],
            participants: [],
        };
    },
    async mounted() {
        this.participants = await this.conversation.getParticipants();

        const galleryContainer = document.querySelector('.js-gallery');

        if (this.gallery === null) {
            this.gallery = lightGallery(galleryContainer, {
                licenseKey: process.env.MIX_LIGHTGALLERY_API_KEY || '0000-0000-000-0000',
                appendCounterTo: '.lg-content',
                dynamic: true,
                download: false,
                share: false,
                mode: 'lg-slide',
                plugins: [lgThumbnail, lgVideo],
                thumbnail: true,
                autoplayVideoOnSlide: true,
                gotoNextSlideOnVideoEnd: false,
                videojs: true,
                videojsOptions: {
                    muted: true,
                },
                dynamicEl: this.dynamicGalleryEl,
            });
        }

        if (this.gallery !== null) {
            this.dynamicGalleryEl = [];
            this.gallery.refresh(this.dynamicGalleryEl);
        }
    },
    methods: {
        addDynamicGalleryEl(data) {
            this.dynamicGalleryEl = [...this.dynamicGalleryEl, data];
            this.gallery.refresh(this.dynamicGalleryEl);
        },
        openGallery(sid) {
            const elIndex = this.dynamicGalleryEl.findIndex((el) => el.sid === sid);
            if (elIndex !== -1) {
                this.gallery.openGallery(elIndex);
            }
        },
    },
};
</script>
